import { ITrustBannerProps, Section, TrustBanner } from '@web_opxp/components';
import { useTranslation } from '@web_opxp/features';

function isLanguageSupported(language: string): boolean {
  // Check if we have trust banners in given language
  return ['en', 'de', 'fr', 'ru'].includes(language);
}

export default function TrustBannerSection() {
  const { language, t } = useTranslation();
  if (!language) {
    return null;
  }
  const trustLanguage = isLanguageSupported(language) ? language : 'en';
  const trustBannerPath = `https://cms.cdn.neuronation.com/assets/edison/trust/v3/${trustLanguage}`;
  const bannerProps: ITrustBannerProps = {
    leftTitle: t('common:TrustBanner.Leonardo.Title'),
    leftItems: [
      { label: t('common:TrustBanner.Leonardo.Award'), src: `${trustBannerPath}/trust1.svg` },
      { label: t('common:TrustBanner.Leonardo.Education'), src: `${trustBannerPath}/trust2.svg` },
      { label: t('common:TrustBanner.Leonardo.Health'), src: `${trustBannerPath}/trust3.svg` },
    ],
    rightTitle: t('common:TrustBanner.Cooperation.Title'),
    rightItems: [
      { label: t('common:TrustBanner.Cooperation.Partner1'), src: `${trustBannerPath}/trust4.svg` },
      { label: t('common:TrustBanner.Cooperation.Partner2'), src: `${trustBannerPath}/trust5.svg` },
      { label: t('common:TrustBanner.Cooperation.Partner3'), src: `${trustBannerPath}/trust6.svg` },
    ],
    popupTitle: t('common.common:LeonardoAwardPopup'),
  };
  return (
    <Section>
      <TrustBanner {...bannerProps} />
    </Section>
  );
}
